module.exports = __webpack_public_path__ + "img/img_brand13.1017ae95.jpg";